export enum InputTypeToDisplay {
    MULTI_SELECT = 'MULTI_SELECT',
    BASIC_INPUT = 'BASIC_INPUT',
    DUAL_INPUT = 'DUAL_INPUT',
    BASIC_DATE = 'BASIC_DATE',
    DUAL_DATE = 'DUAL_DATE',
    NONE = 'NONE',
}
